export { default } from "./VocabularySupportSetting";
